import { all, equals, isEmpty, isNil, isNotNil, values } from 'ramda'

export { isNotNil }
export const isNotEmpty = (value: unknown) => !isEmpty(value)
export const isNotNilOrEmpty = (value: unknown) =>
  isNotNil(value) && isNotEmpty(value)
export const isNilOrEmpty = (value: unknown) => isNil(value) || isEmpty(value)
export const isNullOrUndefined = (value: unknown) =>
  value === null || value === undefined
export const areAllValuesNull = (obj): boolean => all(equals(null), values(obj))
